import { LogLevel } from "@azure/msal-browser";

// Azure AD app-registration values. Fill these in your .env files:
//   REACT_APP_MSAL_CLIENT_ID   -> Application (client) ID
//   REACT_APP_MSAL_TENANT_ID   -> Directory (tenant) ID  (use "common" for multi-tenant)
//   REACT_APP_MSAL_REDIRECT_URI-> Redirect URI registered in Azure (defaults to current origin)
const clientId = (process.env.REACT_APP_MSAL_CLIENT_ID || "").trim();
const tenantId = (process.env.REACT_APP_MSAL_TENANT_ID || "common").trim();
const redirectUri = (
  process.env.REACT_APP_MSAL_REDIRECT_URI ||
  (typeof window !== "undefined" ? window.location.origin : "/")
).trim();

/** True when Azure AD client ID is present (required for Microsoft sign-in). */
export const isMsalConfigured = Boolean(clientId);

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) {
          console.error(message);
        }
      },
    },
  },
};

// Scopes requested when silently acquiring the Microsoft Graph access token.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Scopes/prompt used for the interactive redirect sign-in.
export const microsoftLoginRedirectRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};
